// src/ProfilePage.js
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
	Container,
	IconButton,
	Typography,
	Card,
	CardContent,
	Avatar,
	Grid2,
	Box,
	Button,
	TextField,
	Drawer,
	AppBar,
	Toolbar,
} from "@mui/material";
import { setUser } from "../features/UserSlice";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import logo from "../Malayan.png";
import { sideMenuList, toggleDrawer } from "../utility/utils";

function Profile() {
	// Access user data from Redux store
	const user = useSelector((state) => state.user.user);
	const [drawerOpen, setDrawerOpen] = useState(false);

	const navigate = useNavigate();
	const dispatch = useDispatch();

	if (!user) {
		return <Typography variant="h6">User data not available</Typography>;
	}

	const handleLogout = () => {
		dispatch(setUser(null));
		navigate("/");
	};
	const handleMenuItemClick = (item) => {
		switch (item) {
			case "My Assignments":
			case "All Assignments":
				navigate("/home");
				break;
			case "New Assignment":
				navigate("/claim/New");
				break;
			case "Data Reports":
				navigate("/data-reports");
				break;
			case "Create User":
				navigate("/createUser");
				break;
			case "Change Password":
				navigate("/changePassword");
				break;
			case "Profile":
				navigate("/profile");
				break;
			case "Logout":
				handleLogout();
				break;
			default:
				break;
		}
	};

	return (
		<Box
			sx={{
				width: "100%",
				margin: "auto",
				paddingBottom: 3,
			}}
		>
			<AppBar position="static">
				<Toolbar>
					<IconButton
						edge="start"
						color="inherit"
						aria-label="menu"
						onClick={toggleDrawer(setDrawerOpen)(true)}
					>
						<MenuIcon />
					</IconButton>
					<Box
						component="img"
						src={logo}
						alt="Logo"
						sx={{ height: 40, mr: 2, borderRadius: "50%" }}
					/>
					<Typography variant="h6" sx={{ flexGrow: 1 }}>
						My Profile
					</Typography>
					<IconButton edge="end" color="inherit">
						<Avatar>
							<AccountCircle />
						</Avatar>
					</IconButton>
				</Toolbar>
			</AppBar>
			<Drawer
				anchor="left"
				open={drawerOpen}
				onClose={toggleDrawer(setDrawerOpen)(false)}
			>
				{sideMenuList(
					toggleDrawer(setDrawerOpen),
					handleMenuItemClick,
					user?.role
				)}
			</Drawer>
			<Container maxWidth="sm" sx={{ mt: 4 }}>
				<Card>
					<CardContent>
						<Box
							display="flex"
							alignItems="center"
							flexDirection="column"
							mb={3}
						>
							<Avatar
								sx={{
									bgcolor: "primary.main",
									width: 80,
									height: 80,
								}}
							>
								<AccountCircleIcon sx={{ fontSize: 40 }} />
							</Avatar>
							<Typography
								variant="h5"
								mt={2}
							>{`${user.firstName} ${user.lastName}`}</Typography>
							<Typography
								variant="subtitle1"
								color="textSecondary"
							>
								{user.role}
							</Typography>
						</Box>

						<Grid2 container spacing={2}>
							<Grid2 item size={12}>
								<TextField
									fullWidth
									label="Full Name"
									value={`${user.firstName} ${user.lastName}`}
									slotProps={{
										input: {
											readOnly: true,
										},
									}}
								/>
							</Grid2>
							<Grid2 item size={12}>
								<TextField
									fullWidth
									label="Email"
									value={user.email}
									slotProps={{
										input: {
											readOnly: true,
										},
									}}
								/>
							</Grid2>
							{user.mobileNumber && (
								<Grid2 item size={12}>
									<TextField
										fullWidth
										label="Phone Number"
										value={user.mobileNumber}
										slotProps={{
											input: {
												readOnly: true,
											},
										}}
									/>
								</Grid2>
							)}
							{user.address && (
								<Grid2 item size={12}>
									<TextField
										fullWidth
										label="Address"
										value={user.address}
										slotProps={{
											input: {
												readOnly: true,
											},
										}}
									/>
								</Grid2>
							)}
						</Grid2>
						<Box mt={4} textAlign="center">
							<Button variant="contained" color="primary">
								Edit
							</Button>
						</Box>
					</CardContent>
				</Card>
			</Container>
		</Box>
	);
}

export default Profile;
